module.exports = __webpack_public_path__ + "img/bhutan-1.f14bdee5.svg";